module.exports = __webpack_public_path__ + "static/media/martins.e247205c.jpg";